/** coco+ の下部ナビ「ビデオ通話」タブ（デザイン 3-1 / 3-2） */
export const videoCallTab = {
  title: "ビデオ通話",
  /** 未課金（3-1）：まずはメッセージから */
  unpaidSectionTitle: "今話せる女の子",
  unpaidSectionHint: "まずはメッセージで話して、気が合ったらビデオ通話",
  /** 課金済み（3-2）：前に話した子・推し、今すぐ通話できる子 */
  favoriteOnlineTitle: "前に話した子・推しがオンライン",
  paidSectionTitle: "今すぐビデオ通話できる女の子",
  online: "オンライン",
  favorite: "推し",
  nameAge: (args: { name: string; age?: number }) =>
    args.age ? `${args.name} ${args.age}` : args.name,
  score: (args: { score: number }) => args.score.toFixed(1),
  sendMessage: "メッセージを送る",
  message: "メッセージ",
  videoCall: "ビデオ通話",
  /** 「ビデオ 230 pt/分」。price だけピンクで強調する */
  videoPricePrefix: "ビデオ",
  videoPriceSuffix: "pt/分",
  empty: "いま通話できる女の子はいません。",
} as const;
